// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"xqmtemLyOJaHLW9OaX8sY","linksWrapper":"fnh3GdcVR62AClQZxdHO","link":"_3v0WEJClHfB1MgYbZ0Mh0Z","tooltip":"IK52a-Fkzzmxzl1DOzCgW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReviewSites/ReviewSites.scss
// module id = 1764
// module chunks = 0